export default function ($http) {
    return function (vehicleId, discrepancyId, resolvedState) {
        return $http.put(`api/vehicles/${ vehicleId }/discrepancies/${ discrepancyId }/resolvedState`, {
            resolvedState
        });
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/discrepancies/updateDiscrepancyResolvedState.js